/* eslint-disable nonblock-statement-body-position */
import { useState, useEffect, useRef } from "react";
import PageTitle from "../../../components/PageTitle";
import { Grid } from "@mui/material";
import useStyles from "../styles";
// import { Numbers } from "../../../../utils/DropDown";
import QuestionCard from "../../studentexam/components/QuestionCard";
import PageLoader from "../../../components/PageLoader";
import ProgressBar from "@ramonak/react-progress-bar";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import { useParams, useNavigate } from "react-router-dom";
import { httprequest } from "../../../data/api";
// import { Icon } from "@iconify/react/dist/iconify.js";
import { toast } from "react-toastify";
import Button from "../../../components/Button";
import Modal from "../../../components/Modal";
import { questionDisplayIndex } from "../../../utils/questionDisplayIndex";

const TEST_ENDPOINT = "/api/v1/ca-test/";

const EnrolTest = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [applicantTest, setApplicantTest] = useState({});
  const [percentage, setPercentage] = useState(100);
  const [timer, setTimer] = useState("00:00:00");
  const classes = useStyles();
  // const theme = useTheme();
  const [isLoading, setIsLoading] = useState(false);
  // const isSmallScreen = useMediaQuery(theme.breakpoints.down("lg"));
  const [totalTime, setTotalTime] = useState({});
  const [isTestStarted, setIsTestStarted] = useState(false);
  const applicantTestRef = useRef(applicantTest);
  const [activeQuestion, setActiveQuestion] = useState(null);
  const [activeQuestionIndex, setActiveQuestionIndex] = useState(0);
  const [leaveModal, setLeaveModal] = useState(false);
  // const [timeStamp, setTimeStamp] = useState(0);
  const timeStampRef = useRef(0);
  // eslint-disable-next-line no-unused-vars
  const [selectedAnswer, setSelectedAnswer] = useState({
    answers: []
  });
  const [resultModal, setResultModal] = useState(false);
  const [resultData, setResultData] = useState(null);
  const [submitMessage, setSubmitMessage] = useState("");

  /**
 * Closes the leave exam confirmation modal.
 *
 */
  const handleCloseLeaveModal = () => {
    setLeaveModal(false);
  };

  /**
 * Opens the modal to confirm if the student wants to leave the exam.
 *
 */
  const handleLeaveTestModal = () => {
    setLeaveModal(true);
  };

  /**
 * Advances to the next question in the test.
 * Ensures the index stays within the bounds of the question list.
 *
 */
  const handleNext = () => {
    if (applicantTest?.questions && activeQuestionIndex < applicantTest?.questions?.length - 1) {
      setActiveQuestionIndex(prevIndex => prevIndex + 1);
    }
  };

  /**
 * Navigates to the previous question in the assignment.
 * Prevents going to a negative index.
 *
 */
  const handlePrevious = () => {
    if (activeQuestionIndex > 0) {
      setActiveQuestionIndex(prevIndex => prevIndex - 1);
    }
  };

  /**
 * useEffect - Runs once on component mount.
 * Fetches assignment data from the server and populates student answers.
 * If the assignment is expired, displays a toast and redirects the student.
 */
  useEffect(() => {
    const fetchExam = async () => {
      try {
        setIsLoading(true);
        const data = await httprequest.get(`${TEST_ENDPOINT}${id}`);
        setApplicantTest(data?.data?.data);
        setTotalTime(data?.data?.data?.duration);
        setSelectedAnswer({
          answers: data?.data?.data?.questions.map((question) => ({
            question_index: question.question_index,
            answer: question.answer
          }))
        });
      } catch (err) {
        toast.error(err?.response?.data?.message);
        setTimeout(() => {
          navigate("/assesments/student-test");
        }, 3000);
      } finally {
        setIsLoading(false);
      }
    };
    fetchExam();
  }, []);

  /**
   * Handle navigation after leaving the test
   */
  const handleNavigate = () => {
    localStorage.removeItem(`examTimestamp_${id}`);
    localStorage.removeItem(`remainingTime_${id}`);
    localStorage.removeItem(`timer_${id}`);
    setIsTestStarted(false);
    setTimeout(() => {
      navigate("/assesments/student-test");
    }, 1000);
  };

  /**
 * Handles the selection of an answer for a specific question.
 * Updates the `studentAssignment` state, local storage, and `selectedAnswer` state accordingly.
 *
 * @param {number} questionIndex - The index of the question being answered.
 * @param {string} answer - The selected answer value.
 * @param {string} type - The type of question (e.g., "checkbox", "multiple_choice").
 *
 */
  const handleAnswerClick = (questionIndex, answer, type) => {
    // Update only the selected question's answer
    const updatedQuestions = applicantTest.questions.map((question) => {
      if (question.question_index === questionIndex) {
        const updatedQuestion = { ...question };

        if (type === "checkbox") {
          // Initialize the answer array if not present
          if (!updatedQuestion.answer) {
            updatedQuestion.answer = [];
          }

          const answerIndex = updatedQuestion.answer.indexOf(answer);
          if (answerIndex !== -1) {
            // Uncheck the answer
            updatedQuestion.answer.splice(answerIndex, 1);
          } else {
            // Check the answer
            updatedQuestion.answer.push(answer);
          }
        } else if (type === "multiple_choice") {
          // Replace the current answer for single-choice questions
          updatedQuestion.answer = [answer];
        }

        return updatedQuestion;
      }

      return question;
    });

    // Create the updated exam object
    const updatedExam = {
      ...applicantTest,
      questions: updatedQuestions,
      description: applicantTest?.description === "" ? "Attempt questions" : applicantTest?.description
    };

    const updatedSelectedAnswer = updatedQuestions.map((question) => ({
      question_index: question.question_index,
      answer: question?.answer
    }));

    // Create the updated exam payload to send to backend
    const payload = {
      ...updatedExam,
      questions: updatedExam.questions.map(q => ({
        ...q,
        type: q.type === "true_false" ? "multiple_choice" : q.type
      }))
    };

    // Send the updated
    httprequest
      .post(`${TEST_ENDPOINT}${id}/cache`, payload)
      .then(() => {
        // Update the state locally to reflect changes without re-fetching
        setApplicantTest(updatedExam);
        setSelectedAnswer({ answers: updatedSelectedAnswer });
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message);
      });
  };

  /**
 * Retrieves the last answered question from the selected answers and its corresponding question index.
 *
 * Filters the `selectedAnswer.answers` array to include only those with a non-empty `answer`,
 * then selects the last item in the filtered list.
 *
 * @type {Object} lastAnswered - The last item in `answers` that has a non-empty `answer` field.
 * @type {number} lastQuestionIndex - The index of the last answered question, defaults to 1 if not found.
 */
  const lastAnswered = selectedAnswer?.answers
    .filter(item => item?.answer && item?.answer.length > 0)
    .at(-1); // gets the last item in the filtered list

  const lastQuestionIndex = lastAnswered?.question_index ?? 1;

  /**
 * Submits the final answers of the exam to the server.
 * Clears local storage and navigates away after a successful or failed submission.
 *
 * @async
 * @returns {Promise<void>}
 */
  const handleFinalSubmit = async (applicantTest) => {
    try {
      timeStampRef.current = 0;
      const correctedExam = {
        ...applicantTest,
        description: applicantTest?.description === "" ? "Attempt questions" : applicantTest?.description,
        questions: applicantTest?.questions?.map(q => ({
          ...q,
          type: q.type === "true_false" ? "multiple_choice" : q.type
        }))
      };
      const res = await httprequest.post(`${TEST_ENDPOINT}${id}/submit`, correctedExam);

      localStorage.removeItem(`examTimestamp_${id}`);
      localStorage.removeItem(`remainingTime_${id}`);
      localStorage.removeItem(`timer_${id}`);
      setIsTestStarted(false);

      const shouldDisplayScore = applicantTest?.display_score_after_test_date ||
                                 applicantTest?.config?.display_score_after_test_date ||
                                 applicantTest?.config?.display_score_after_exam ||
                                 applicantTest?.display_score_after_exam;

      if (shouldDisplayScore && res?.data?.data) {
        setResultData(res.data.data);
        setSubmitMessage(res?.data?.message || "Test submitted successfully");
        setResultModal(true);
      } else {
        toast.success(res?.data?.message);
        setTimeout(() => {
          handleNavigate();
        }, 1000);
      }
    } catch (err) {
      toast.error(err?.response?.data?.message);
    }
  };

  /**
 * Navigates to the specified question index.
 * Updates the active question state.
 *
 * @param {number} index - The index of the question to navigate to.
 *
 */
  const handleNavigateToQuestion = (index) => {
    setActiveQuestion(index);
    setActiveQuestionIndex(index);
    if (applicantTest?.questions_display_mode === "all_at_once") {
      const questionIndex = applicantTest?.questions[index]?.question_index;
      const idElement = document.getElementById(`question_${questionIndex}`);
      if (idElement) {
        idElement.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }
  };

  /**
 * Checks if a given question has been answered by the student.
 *
 * @param {number} questionIndex - The index of the question to check.
 * @returns {boolean} `true` if the question has an answer, otherwise `false`.
 */
  const isQuestionAnswered = (questionIndex) => {
    return selectedAnswer?.answers.some(
      (a) => a?.question_index === questionIndex && a?.answer?.length > 0
    ) || false;
  };

  /**
 * Starts the exam by updating the `isExamStarted` state to true.
 *
 */
  const handleStartTest = () => {
    if (totalTime > 0) {
      setIsTestStarted(true);
      const totalSeconds = totalTime * 60;
      const deadline = Date.now() + totalSeconds * 1000;

      const interval = setInterval(() => {
        const remainingTime = Math.max(0, deadline - Date.now());

        const hours = Math.floor((remainingTime / (1000 * 60 * 60)) % 24);
        const minutes = Math.floor((remainingTime / (1000 * 60)) % 60);
        const seconds = Math.floor((remainingTime / 1000) % 60);

        setTimer(
          `${hours > 9 ? hours : `0${hours}`}:${minutes > 9 ? minutes : `0${minutes}`}:${seconds > 9 ? seconds : `0${seconds}`}`
        );

        const percentageRemaining = Math.round((remainingTime / (totalTime * 60 * 1000)) * 100);
        setPercentage(100 - percentageRemaining);

        // Save remaining time and pause exam on reload
        // if (performance.navigation.type === performance.navigation.TYPE_RELOAD) {
        //   timeStampRef.current = remainingTime;
        //   clearInterval(interval);

        //   return;
        // }

        const secondsInCurrentMinute = remainingTime % 60000;

        // Check if secondsInCurrentMinute is within a few seconds of a new minute
        if (secondsInCurrentMinute < 1000) {
          localStorage.setItem(`examTimestamp_${id}`, remainingTime);
          localStorage.setItem(`remainingTime_${id}`, 100 - percentageRemaining);
          localStorage.setItem(`timer_${id}`, `${hours > 9 ? hours : `0${hours}`}:${minutes > 9 ? minutes : `0${minutes}`}:${seconds > 9 ? seconds : `0${seconds}`}`);
        }

        if (remainingTime === 0) {
          handleFinalSubmit(applicantTestRef.current);
          clearInterval(interval);
        }
      }, 1000);

      return () => clearInterval(interval);
    }
  };

  /**
 * Continues the exam (e.g., after a reload) by setting `isExamStarted` to true.
 *
 */
  const handleContinueTest = () => {
    if (totalTime > 0) {
      setIsTestStarted(true);
      setActiveQuestionIndex(lastQuestionIndex - 1);

      // timeStampRef.current = localStorage.getItem("examTimestamp")
      //   ? Number(localStorage.getItem("examTimestamp"))
      //   : totalTime * 60 * 1000;

      const interval = setInterval(() => {
        // Calculate remaining time
        const remainingTime = Math.max(0, timeStampRef.current - 1000);
        timeStampRef.current = remainingTime;

        // Calculate hours, minutes, and seconds
        const hours = Math.floor((remainingTime / (1000 * 60 * 60)) % 24);
        const minutes = Math.floor((remainingTime / (1000 * 60)) % 60);
        const seconds = Math.floor((remainingTime / 1000) % 60);

        // Update the timer display
        setTimer(
          `${hours > 9 ? hours : `0${hours}`}:${minutes > 9 ? minutes : `0${minutes}`}:${seconds > 9 ? seconds : `0${seconds}`}`
        );

        // Calculate the percentage remaining
        const percentageRemaining = Math.round((remainingTime / (totalTime * 60 * 1000)) * 100);
        setPercentage(100 - percentageRemaining);

        const secondsInCurrentMinute = remainingTime % 60000;

        // Check if secondsInCurrentMinute is within a few seconds of a new minute
        if (secondsInCurrentMinute < 1000) {
          localStorage.setItem(`examTimestamp_${id}`, remainingTime);
          localStorage.setItem(`remainingTime_${id}`, 100 - percentageRemaining);
          localStorage.setItem(`timer_${id}`, `${hours > 9 ? hours : `0${hours}`}:${minutes > 9 ? minutes : `0${minutes}`}:${seconds > 9 ? seconds : `0${seconds}`}`);
        }

        if (remainingTime === 0) {
          handleFinalSubmit(applicantTestRef.current);
          clearInterval(interval);
        }
      }, 1000);

      return () => clearInterval(interval);
    }
  };

  /**
   * Restore exam state after reload
   */
  useEffect(() => {
    const savedTimestamp = localStorage.getItem(`examTimestamp_${id}`);
    const RemainingTime = localStorage.getItem(`remainingTime_${id}`);
    const Time = localStorage.getItem(`timer_${id}`);

    // If there's a saved timestamp, set the timeStampRef and update the percentage and timer
    if (savedTimestamp) {
      timeStampRef.current = parseInt(savedTimestamp);
      setPercentage(RemainingTime);
      setTimer(Time);

      // If the saved timestamp is valid, continue the exam
      setIsTestStarted(false);
    }
  }, []);

  useEffect(() => {
    const handleContextMenu = (e) => {
      e.preventDefault();
    };

    // Attach when component mounts
    document.addEventListener("contextmenu", handleContextMenu);

    // Cleanup on unmount
    return () => {
      document.removeEventListener("contextmenu", handleContextMenu);
    };
  }, []);

  useEffect(() => {
    applicantTestRef.current = applicantTest;
  }, [applicantTest]);

  return (
    <div className={classes.testcont}>
      <div className={`${classes.mainpage} page-content`}>
        <PageTitle
          title={applicantTest?.title || "My Assessment"}
          subtitle={applicantTest?.instruction || "Read Instructions well before starting the assessment"}
          button={
            <div className="flex gap-10">
              <Button
                variant="dangeroutline"
                buttonSize="fluid"
                color="btndanger"
                buttonName="Leave Test"
                onClick={handleLeaveTestModal}
              />
              <Button
                variant="primary"
                buttonSize="fluid"
                color="btndefault"
                buttonName="Submit Test"
                onClick={() => handleFinalSubmit(applicantTestRef.current)}
              />
            </div>
          }
        />
        <div className="margin-top-30">
          <Grid container spacing={2}>
            <Grid item lg={9} md={9} sm={12} xs={12}>
              <div className={`${classes.progressbar} padding-inline-10`}>
                <ProgressBar completed={100 - percentage} baseBgColor="#F0F2F5" bgColor="#28AE00" labelSize="12px" height="14px" />
                <div className={classes.timeleft}>
                  <h2>Time Remaining: {timer}</h2>
                </div>
              </div>
              {/* Fetch temporary draft */}
              <div>
                <div>
                  {isLoading ? (
                    <PageLoader />
                  ) : (
                    <>
                      {!isTestStarted ? (
                        <>
                          <div className={`${classes.getcont}`}>
                            <p className={classes.getstarted}>Please read the following instructions carefully</p>
                            <div className={classes.instructioncont}>
                              <p>1. Ensure a stable internet connection, a compatible device, and a quiet environment</p>
                              <p>2. Follow all exam rules — no external help, no switching tabs, no unauthorized materials.</p>
                              <p>3. Manage your time and complete all questions before submission.</p>
                              <p>4. Review your answers and wait for confirmation before exiting.</p>
                            </div>
                            <Grid container spacing={1}>
                              <Grid item lg={6} md={6} sm={12} xs={12}>
                                <div className={`${classes.enroldetails} flex gap-10`}>
                                  <p className={classes.subtitles}>Subject:</p>
                                  <p>{applicantTest?.subject?.name || "--/--"}</p>
                                </div>
                              </Grid>
                              <Grid item lg={6} md={6} sm={12} xs={12}>
                                <div className={`${classes.enroldetails} flex gap-10`}>
                                  <p className={classes.subtitles}>Total Questions:</p>
                                  <p>{applicantTest?.questions?.length}</p>
                                </div>
                              </Grid>
                              <Grid item lg={6} md={6} sm={12} xs={12}>
                                <div className={`${classes.enroldetails} flex gap-10`}>
                                  <p className={classes.subtitles}>Marks:</p>
                                  <p>{applicantTest?.total_grade || "--/--"}</p>
                                </div>
                              </Grid>
                              <Grid item lg={6} md={6} sm={12} xs={12}>
                                <div className={`${classes.enroldetails} flex gap-10`}>
                                  <p className={classes.subtitles}>Total Duration:</p>
                                  <p>{applicantTest?.duration || "--/--"} mins</p>
                                </div>
                              </Grid>
                            </Grid>
                          </div>
                          <div className={classes.btns}>
                            <div>
                              <Button
                                onClick={handleNavigate}
                                variant="dangeroutline"
                                buttonName="Cancel"
                                buttonSize="large"
                                color="btndanger"
                              />
                            </div>
                            <div>
                              {!isTestStarted && (
                                <div className="margin-bottom">
                                  {timeStampRef.current > 0 ? (
                                    <Button
                                      onClick={handleContinueTest}
                                      variant="primary"
                                      buttonName="Continue Test"
                                      buttonSize="large"
                                      color="btndefault"
                                    />
                                  ) : (
                                    <Button
                                      onClick={handleStartTest}
                                      variant="primary"
                                      buttonName="Start Test"
                                      buttonSize="large"
                                      color="btndefault"
                                    />
                                  )}
                                </div>
                              )}
                            </div>
                          </div>
                        </>
                      ) : (
                        <>
                          <div className={`${classes.questionmaincont} container-y-overflow`}>
                            {applicantTest?.questions && applicantTest?.questions.length > 0 && (
                              applicantTest?.questions_display_mode === "all_at_once" ? (
                                applicantTest?.questions.map((item, index) => (
                                  <div key={index} className="margin-bottom-20">
                                    <QuestionCard
                                      id={`question_${index + 1}`}
                                      arrayIndex={index}
                                      questions={applicantTest?.questions}
                                      item={item}
                                      onAnswerClick={(answer) => handleAnswerClick(
                                        item?.question_index,
                                        answer - 1,
                                        item?.type
                                      )}
                                    />
                                  </div>
                                ))
                              ) : (
                                <QuestionCard
                                  id={`question_${activeQuestionIndex + 1}`}
                                  key={activeQuestionIndex + 1}
                                  arrayIndex={activeQuestionIndex}
                                  questions={applicantTest?.questions}
                                  item={applicantTest?.questions[activeQuestionIndex]}
                                  onAnswerClick={(answer) => handleAnswerClick(
                                    applicantTest?.questions[activeQuestionIndex]?.question_index,
                                    answer - 1,
                                    applicantTest?.questions[activeQuestionIndex]?.type
                                  )}
                                />
                              )
                            )}
                          </div>
                          <div className={classes.desktopbtns}>
                            <div className={classes.submitbtn}>
                              {applicantTest?.questions_display_mode !== "all_at_once" && (
                                <Button
                                  onClick={handlePrevious}
                                  variant="primaryoutline"
                                  color="btnfontprimary"
                                  buttonName="Previous"
                                  buttonSize="medium"
                                  disabled={activeQuestionIndex === 0}
                                />
                              )}

                              {(applicantTest?.questions_display_mode === "all_at_once" || activeQuestionIndex === applicantTest?.questions.length - 1) ? (
                                <Button
                                  variant="primary"
                                  buttonSize="medium"
                                  color="btndefault"
                                  buttonName="Submit Test"
                                  onClick={() => handleFinalSubmit(applicantTestRef?.current)}
                                />
                              ) : (
                                <Button
                                  onClick={handleNext}
                                  variant="primary"
                                  color="btndefault"
                                  buttonName="Next"
                                  buttonSize="medium"
                                  disabled={activeQuestionIndex === applicantTest?.questions.length - 1}
                                />
                              )}
                            </div>
                          </div>
                        </>
                      )}
                    </>
                  )}
                </div>
              </div>
            </Grid>
            <div className={classes.mobilescont}>
              <div className={classes.mobiles}>
                {isTestStarted && (
                  <div className={classes.submitbtn}>
                    {applicantTest?.questions_display_mode !== "all_at_once" && (
                      <Button
                        onClick={handlePrevious}
                        variant="primaryoutline"
                        color="btnfontprimary"
                        buttonName="Previous"
                        buttonSize="medium"
                        disabled={activeQuestionIndex === 0}
                      />
                    )}

                    {(applicantTest?.questions_display_mode === "all_at_once" || activeQuestionIndex === applicantTest?.questions?.length - 1) ? (
                      <Button
                        variant="primary"
                        buttonSize="medium"
                        color="btndefault"
                        buttonName="Submit Test"
                        onClick={() => handleFinalSubmit(applicantTestRef?.current)}
                      />
                    ) : (
                      <Button
                        onClick={handleNext}
                        variant="primary"
                        color="btndefault"
                        buttonName="Next"
                        buttonSize="medium"
                        disabled={activeQuestionIndex === applicantTest?.questions?.length - 1}
                      />
                    )}
                  </div>
                )}
                {isTestStarted && (
                  <div className={`${classes.questioncont}`}>
                    <h5>QUESTIONS</h5>
                    <Grid container spacing={1}>
                      {applicantTest && applicantTest?.questions ? (
                        applicantTest?.questions.map((queNumber, index) => (
                          <Grid item key={index} lg={2} md={2} sm={1} xs={2}>
                            <p onClick={() => handleNavigateToQuestion(index)}
                              style={{
                                backgroundColor: isQuestionAnswered(queNumber?.question_index) ? "#d4edda" : (activeQuestion === index ? "#F0F2F5" : "transparent"),
                                fontWeight: activeQuestion === index ? "bold" : "normal"
                              }}
                            >{questionDisplayIndex(queNumber, index, applicantTest?.questions)}
                            </p>
                          </Grid>
                        ))
                      ) : (
                        <p>Please Wait ...</p>
                      )}
                    </Grid>
                    {/* <Button onClick={() => handleFinalSubmit(applicantExamRef.current)} variant="primary" buttonName="Submit Exam" buttonSize="full" color="btndefault" /> */}
                  </div>
                )}
              </div>
            </div>
            <Grid item lg={3} md={3} sm={12} xs={12}>
              <div className={`${classes.rightcont}`}>
                {/* {!isTestStarted && (
                  <div className="margin-bottom">
                    {timeStampRef.current > 0 ? (
                      <Button
                        onClick={handleContinueTest}
                        variant="primary"
                        buttonName="Continue Test"
                        buttonSize="full"
                        color="btndefault"
                      />
                    ) : (
                      <Button
                        onClick={handleStartTest}
                        variant="primary"
                        buttonName="Start Test"
                        buttonSize="full"
                        color="btndefault"
                      />
                    )}
                  </div>
                )} */}
                <div className={classes.timercont}>
                  <h5>Timer</h5>
                  <div className={classes.times}>
                    <CircularProgressbar counterClockwise background value={100 - percentage} text={timer} strokeWidth={5}
                      styles={buildStyles({
                        textColor: "#000000",
                        pathColor: "#28AE00",
                        trailColor: "#FFF",
                        textSize: "20px",
                        strokeLinecap: "butt",
                        textWeight: "400"
                      })}
                    />
                  </div>
                </div>
                <div className={`${classes.questioncont}`}>
                  <h5>QUESTIONS</h5>
                  <Grid container spacing={1}>
                    {applicantTest && applicantTest?.questions ? (
                      applicantTest?.questions.map((queNumber, index) => (
                        <Grid item key={index} lg={2} md={2} sm={1} xs={2}>
                          <p onClick={() => handleNavigateToQuestion(index)}
                            style={{
                              backgroundColor: isQuestionAnswered(queNumber?.question_index) ? "#d4edda" : (activeQuestion === index ? "#F0F2F5" : "transparent"),
                              fontWeight: activeQuestion === index ? "bold" : "normal"
                            }}
                          >{questionDisplayIndex(queNumber, index, applicantTest?.questions)}
                          </p>
                        </Grid>
                      ))
                    ) : (
                      <p>Please Wait ...</p>
                    )}
                  </Grid>
                  {/* <Button onClick={() => handleFinalSubmit(applicantTestRef.current)} variant="primary" buttonName="Submit Test" buttonSize="full" color="btndefault" /> */}
                </div>
              </div>
            </Grid>
          </Grid>
        </div>
      </div>
      {/* Leave Exam Modal */}
      <Modal
        title="Leave Test"
        subtitle={
          <div>
                Are you sure you want to Leave this Test?
          </div>
        }
        modalContent={<></>}
        modalFooter={
          <>
            <div className="flex gap-10">
              <Button
                variant="dangeroutline"
                buttonSize="full"
                color="btndanger"
                buttonName="Cancel"
                onClick={handleCloseLeaveModal}
              />
              <Button
                variant="danger"
                buttonName="Leave Test"
                buttonSize="full"
                color="btndefault"
                onClick={handleNavigate}
              />
            </div>
          </>
        }
        isopen={leaveModal}
        handleClose={handleCloseLeaveModal}
      />

      <Modal
        title="Test Result"
        isopen={resultModal}
        handleClose={() => {
          setResultModal(false);
          handleNavigate();
        }}
        modalContent={
          <div style={{ textAlign: "center", padding: "20px" }}>
            <h2 style={{ fontSize: "24px", fontWeight: "bold", color: "#333" }}>Your Score</h2>
            <p style={{ fontSize: "48px", color: "#0065FF", margin: "20px 0", fontWeight: "bold" }}>
              {resultData?.score ?? resultData?.student_score ?? "--"} / {resultData?.obtainable_score ?? resultData?.total_score ?? "--"}
            </p>
            <p style={{ color: "#667185" }}>{submitMessage}</p>
          </div>
        }
        modalFooter={
          <div style={{ width: "100%", display: "flex", justifyContent: "center" }}>
            <Button
              onClick={() => {
                setResultModal(false);
                handleNavigate();
              }}
              variant="primary"
              buttonName="Continue"
            />
          </div>
        }
      />
    </div>
  );
};

export default EnrolTest;
